import { FormGroup } from './formGroup';

export class FormStep extends FormGroup {}
